import { useRealTimeTypedQuery } from "components";
import { useCustomerInfoListeners } from "modules/CarDetails/hooks/useCustomerInfoListeners";
import { CarDetailsQueryKeys } from "modules/CarDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Appointment, Customer } from "models";

export type CarCustomerInfo = {
  current_km: number;
  owner_opted_out_from_importing: boolean;
  driver_opted_out_from_importing: boolean;
  contractor_opted_out_from_importing: boolean;
  owner?: Customer;
  driver?: Customer;
  contractor?: Customer;
};

const getCustomerInfo = (appointment: Appointment): CarCustomerInfo => ({
  current_km: appointment.current_km,
  contractor: appointment.customer_contract,
  driver: appointment.customer_driver,
  owner: appointment.customer_owner,
  owner_opted_out_from_importing: appointment.owner_opted_out_from_importing,
  driver_opted_out_from_importing: appointment.driver_opted_out_from_importing,
  contractor_opted_out_from_importing: appointment.contractor_opted_out_from_importing
});

export const useCustomerInfoQuery = (latestAppointmentId: number = 0) => {
  const listeners = useCustomerInfoListeners(latestAppointmentId);

  const query = useRealTimeTypedQuery({
    enabled: !!latestAppointmentId,
    queryKey: CarDetailsQueryKeys.customerInfo(latestAppointmentId),
    listeners,
    queryFn: async ({ baseUrl, endpoint, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data,
    select: getCustomerInfo
  });

  return query;
};
